import { FlattenInterpolation, FlattenSimpleInterpolation, ThemeProps } from "packages/styled-components";

export type Template = FlattenSimpleInterpolation | FlattenInterpolation<ThemeProps<any>>;

export const setProps =
  <Props>(flagFunction: (props: Props) => Props[keyof Props]) =>
  (template: Template) =>
  (props: Props): string | Template =>
    flagFunction(props) && template;
